import React from 'react'
import { AccordionComponentProps } from './AccordionWrapper.types'
import { transformRegionToMap } from '@utils/pageUtils'
import Accordion from '@molecules/Accordion/Accordion'
import { AccordionItem } from '@molecules/Accordion/Accordion.types'

const AccordionWrapper = ({
  data,
  regions = [],
  custom
}: AccordionComponentProps) => {
  const accordionItems =
    transformRegionToMap(regions)?.get('accordions')?.components || []

  const fallbackImage = custom?.content?.parentImage?.path ?? ''

  const idToImageMapping = new Map()
  let defaultOpenAccordionImage = ''
  let defaultOpenAccordionItemId = ''

  //Set the image of the first opened accordion item
  const accordionItemList: AccordionItem[] = []

  accordionItems.map((itemRow: any) => {
    if (
      itemRow.data?.defaultOpen &&
      itemRow.data?.image &&
      defaultOpenAccordionImage === ''
    ) {
      defaultOpenAccordionImage = itemRow.custom?.content?.image?.path
    }
    if (itemRow?.data?.defaultOpen && defaultOpenAccordionItemId === '') {
      defaultOpenAccordionItemId = itemRow.id
    }
    idToImageMapping.set(
      itemRow.id,
      itemRow.custom?.content?.image?.path || fallbackImage
    )
    accordionItemList.push({
      id: itemRow.id,
      headlineIndex: itemRow.data?.headlineIndex,
      headline: itemRow.data?.headline,
      imagePath: itemRow.custom?.content?.image?.path,
      imageAlt: itemRow.data?.imageAlt,
      regions: itemRow.regions
    })
  })

  return (
    <Accordion
      defaultOpenAccordionImage={defaultOpenAccordionImage}
      accordionItems={accordionItemList}
      idToImageMapping={idToImageMapping}
      defaultOpenAccordionItemId={defaultOpenAccordionItemId}
      bgStyle={data?.bgStyle}
      fullWidth={data?.fullWidth}
      accordionHeadline={data?.accordionHeadline}
      fallbackImage={fallbackImage}
      fallbackImageAlt={data?.imageAlt}
      imagePosition={data?.imagePosition}
    />
  )
}

export default AccordionWrapper
